import cxs from 'cxs';
import { COLOURS, FLATTENED_COLOURS } from '../../../common/styles/vars';

const MINIMISED_HEIGHT = '60px';
const MENU_TRANSITION = { transition: 'height .3s ease-in-out' };
const MENU_PADDING = { padding: '10px 20px' };
const FIXED_MENU = {
  position: 'fixed',
  background: 'inherit',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10
};

export const MENU_CONTAINER = (primaryColour) => cxs({
  background: primaryColour ? FLATTENED_COLOURS[primaryColour] : COLOURS.mono.white,
  width: '100%',
  height: MINIMISED_HEIGHT
});

export const MENU = cxs({
  boxSizing: 'border-box',
  flexDirection: 'row',
  display: 'flex',
  color: COLOURS.mono.white,
  height: MINIMISED_HEIGHT,
  ...FIXED_MENU,
  ...MENU_PADDING,

  ' > *:last-child': {
    marginLeft: 'auto'
  }
});

export const MENU_EXPANDED_HEADER = cxs({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '60px',
  minHeight: '60px'
});

export const CLOSE_BTN = cxs({
  cursor: 'pointer',
  flex: 1,
  justifyContent: 'start',
  height: '60px',
  marginRight: '50px'
});

export const GLOBAL_SEARCH = cxs({
  color: COLOURS.mono.white,
  width: '40px',
  marginRight: '30px',
  transition: 'width .6s',
  marginLeft: '20px',
  borderRadius: '6px',

  ' > .icon-container:last-of-type:not(:first-of-type)': {
    right: '15px !important'
  },

  ' input': {
    backgroundColor: 'transparent',
    color: COLOURS.mono.black,
    paddingRight: '15px !important',
    borderRadius: '6px',
    height: '100%',
    minHeight: '100%',

    '::placeholder': {
      color: COLOURS.grey.regent
    }
  }
});

export const GLOBAL_SEARCH_ACTIVE = cxs({
  width: '100% !important',
  background: COLOURS.grey.athens.bigFat,
  paddingRight: '20px'
});

export const MENU_EXPANDED_CONTAINER = (minimised) => cxs({
  display: 'flex',
  flexDirection: 'column',
  height: minimised ? 0 : '100%',
  padding: '0 20px',
  overflow: 'hidden',
  zIndex: 1500,
  boxSizing: 'border-box',
  width: '100%',
  bottom: 0,
  ...FIXED_MENU,
  ...MENU_TRANSITION
});

export const TOP_MENU_LINKS = cxs({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  marginBottom: '35px',
  marginTop: '20px',

  ' > button': {
    minHeight: '40px',
    height: '40px'
  }
});

export const BOTTOM_MENU_LINKS = cxs({
  marginBottom: '20px',

  ' > button': {
    minHeight: '40px',
    height: '40px'
  }
});

export const USER_INFO = ({ primaryLinksColour }) => cxs({
  display: 'flex',
  paddingLeft: '20px',
  marginBottom: '20px',

  ' .text': {
    color: primaryLinksColour || void 0
  }
});

export const USER_INFO_TEXT = cxs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: '20px'
});